<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form v-slot="{ values }" @submit="addPricingRule" :validation-schema="pricingRuleSchema"
        ref="pricingRuleForm">

        <div class="row">

          <!-- ===== ÉTAPE 1 : INFORMATIONS DE BASE ===== -->
          <div class="col-md-12 mb-3">
            <div class="alert alert-primary">
              <strong>Étape 1 :</strong> Informations de base de la règle de tarification
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Code <span class="text-danger">*</span>
              </label>
              <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Ex: BESC-BJ-DOSSIER" />
              <ErrorMessage name="code" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom <span class="text-danger">*</span>
              </label>
              <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Ex: Frais de dossier" />
              <ErrorMessage name="name" class="text-danger" />
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Zone Tarifaire <span class="text-danger">*</span>
              </label>
              <Field name="tariffZoneId" v-slot="{ field }">
                <Multiselect :options="tariffZoneOptions" :searchable="true" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner la zone" />
              </Field>
              <ErrorMessage name="tariffZoneId" class="text-danger" />
            </div>
          </div>

          <!-- ===== ÉTAPE 2 : TYPE D'ENTITÉ ===== -->
          <div class="col-md-12 mt-3 mb-3">
            <div class="alert alert-info">
              <strong>Étape 2 :</strong> Sur quel élément cette règle doit-elle s'appliquer ?
            </div>
          </div>

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type d'entité <span class="text-danger">*</span>
              </label>
              <Field name="appliesToEntityType" v-slot="{ field }">
                <Multiselect :options="entityTypeOptions" :searchable="false" track-by="label" label="label"
                  v-model="field.value" v-bind="field" @change="onEntityTypeChange"
                  placeholder="Choisissez le type d'entité..." />
              </Field>
              <ErrorMessage name="appliesToEntityType" class="text-danger" />
            </div>
          </div>

          <!-- Message d'aide -->
          <div class="col-md-12" v-if="selectedEntityType">
            <div class="alert alert-success mb-4">
              <strong>{{ entityTypeHelp.title }}</strong>
              <p class="mb-0 mt-2">{{ entityTypeHelp.description }}</p>
            </div>
          </div>

          <!-- ===== ÉTAPE 3 : CONFIGURATION PRINCIPALE (obligatoire) ===== -->
          <div v-if="selectedEntityType">
            <div class="col-md-12 mt-3 mb-3">
              <div class="alert alert-warning">
                <strong>Étape 3 :</strong> Configuration principale de la règle (obligatoire)
              </div>
            </div>

            <!-- ========== BESC ========== -->
            <!-- <div v-if="selectedEntityType === 'BESC'">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Montant fixe par dossier <span class="text-danger">*</span>
                  </label>
                  <Field name="baseAmount" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 50000" />
                  <ErrorMessage name="baseAmount" class="text-danger" />
                  <small class="text-muted">Ce montant sera facturé une seule fois par BESC</small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Devise <span class="text-danger">*</span>
                  </label>
                  <Field name="amountCurrency" v-slot="{ field }">
                    <Multiselect :options="currencyOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la devise" />
                  </Field>
                  <ErrorMessage name="amountCurrency" class="text-danger" />
                </div>
              </div>
            </div> -->

            <!-- ========== BL ========== -->
            <!-- <div v-if="selectedEntityType === 'BL'">
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Montant par BL <span class="text-danger">*</span>
                  </label>
                  <Field name="baseAmount" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 16437" />
                  <ErrorMessage name="baseAmount" class="text-danger" />
                  <small class="text-muted">Ce montant sera multiplié par le nombre de BL</small>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Devise <span class="text-danger">*</span>
                  </label>
                  <Field name="amountCurrency" v-slot="{ field }">
                    <Multiselect :options="currencyOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la devise" />
                  </Field>
                  <ErrorMessage name="amountCurrency" class="text-danger" />
                </div>
              </div>
            </div> -->

            <!-- ========== CONTAINER ========== -->
            <div v-if="selectedEntityType === 'CONTAINER'" class="row">
              <div class="col-md-12 mb-2">
                <div class="alert alert-success">
                  <strong>Tarification Conteneurs (FCL)</strong>
                </div>
              </div>

              <!-- Ligne 1 : Taille tranche, Unité, Max ECTN -->
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Taille de la tranche <span class="text-danger">*</span>
                  </label>
                  <Field name="trancheSize" type="number" class="form-control" placeholder="5" />
                  <ErrorMessage name="trancheSize" class="text-danger" />
                  <small class="text-muted">Nombre de conteneurs par tranche (ex: 5)</small>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Unité de mesure <span class="text-danger">*</span>
                  </label>
                  <Field name="unitOfMeasure" v-slot="{ field }">
                    <Multiselect :options="unitOfMeasureOptions" :searchable="false" track-by="label" label="label"
                      v-model="field.value" v-bind="field" :disabled="true" />
                  </Field>
                  <ErrorMessage name="unitOfMeasure" class="text-danger" />

                  <ErrorMessage name="unitOfMeasure" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Max par ECTN
                  </label>
                  <Field name="maxPerEctn" type="number" class="form-control" placeholder="Illimité" />
                  <ErrorMessage name="maxPerEctn" class="text-danger" />
                </div>
              </div>

              <!-- Ligne 2 : Tarif, Devise -->
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Tarif applicable <span class="text-danger">*</span>
                  </label>
                  <Field name="amountForOrigin" type="number" step="0.01" class="form-control" placeholder="25" />
                  <ErrorMessage name="amountForOrigin" class="text-danger" />
                  <small class="text-muted">Par tranche de {{ values.trancheSize || 5 }} conteneurs</small>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Devise <span class="text-danger">*</span>
                  </label>
                  <Field name="amountCurrency" v-slot="{ field }">
                    <Multiselect :options="currencyOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" />
                  </Field>
                  <ErrorMessage name="amountCurrency" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Types de conteneur <span class="text-danger">*</span>
                  </label>
                  <Field name="metadata.containerTypes" v-slot="{ field }">
                    <Multiselect :options="containerTypeOptions" :searchable="true" mode="tags" v-model="field.value"
                      v-bind="field" placeholder="Sélectionner un ou plusieurs types" />
                  </Field>
                  <ErrorMessage name="metadata.containerTypes" class="text-danger" />
                  <small class="text-muted">Obligatoire : choisissez les types concernés</small>
                </div>
              </div>

              <!-- Ligne 3 : Checkbox origine lointaine -->
              <!-- <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <div class="form-check">
                    <Field name="metadata.requireDistantOrigin" type="checkbox" class="form-check-input"
                      id="requireDistantOrigin" :value="true" />
                    <label class="form-check-label text-black fw-semibold" for="requireDistantOrigin">
                      Uniquement pour les origines lointaines (Asie, Amérique, Océanie)
                    </label>
                  </div>
                  <small class="text-muted d-block mt-2">
                    Si coché, cette règle ne s'appliquera que si le port de chargement est en Asie, Amérique ou Océanie
                  </small>
                </div>
              </div> -->
            </div>

            <!-- ========== GOODS ========== -->
            <div v-if="selectedEntityType === 'GOODS'" class="row">
              <div class="col-md-12 mb-3">
                <div class="alert alert-info">
                  <strong>Marchandises avec conditionnement</strong>
                  <p class="mb-0 mt-2">
                    Sélectionnez le type de conditionnement pour appliquer la grille tarifaire correspondante
                  </p>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type de conditionnement <span class="text-danger">*</span>
                  </label>
                  <Field name="packagingType" v-slot="{ field }">
                    <Multiselect :options="packagingTypeOptions" :searchable="false" track-by="label" label="label"
                      v-model="field.value" v-bind="field" @change="onPackagingTypeChange"
                      placeholder="Choisissez le type de conditionnement..." />
                  </Field>
                  <ErrorMessage name="packagingType" class="text-danger" />
                </div>
              </div>

              <div v-if="selectedPackagingType" class="row">

                <!-- ROULANT -->
                <div v-if="selectedPackagingType === 'ROULANT'" class="row">
                  <div class="col-md-12 mb-2">
                    <div class="alert alert-success">
                      <strong>Tarification Roulant</strong>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Poids minimum (tonnes) <span class="text-danger">*</span>
                      </label>
                      <Field name="minWeight" type="number" step="0.01"
                        class="form-control shadow-none fs-md-15 text-black" />
                      <ErrorMessage name="minWeight" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Poids maximum (tonnes) <span class="text-danger">*</span>
                      </label>
                      <Field name="maxWeight" type="number" step="0.01"
                        class="form-control shadow-none fs-md-15 text-black" />
                      <ErrorMessage name="maxWeight" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Unité de mesure <span class="text-danger">*</span>
                      </label>
                      <Field name="unitOfMeasure" v-slot="{ field }">
                        <Multiselect :options="unitOfMeasureOptions" :searchable="false" track-by="label" label="label"
                          v-model="field.value" v-bind="field" :disabled="true" />
                      </Field>
                      <ErrorMessage name="unitOfMeasure" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-3">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Max par ECTN <span class="text-danger">*</span>
                      </label>
                      <Field name="maxPerEctn" type="number" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="1" />
                      <ErrorMessage name="maxPerEctn" class="text-danger" />
                      <small class="text-muted">Ex: 1 véhicule maximum par ECTN</small>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Tarif applicable <span class="text-danger">*</span>
                      </label>
                      <Field name="amountForOrigin" type="number" step="0.01" class="form-control" placeholder="25" />
                      <ErrorMessage name="amountForOrigin" class="text-danger" />
                      <small class="text-muted">Par véhicule</small>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Devise <span class="text-danger">*</span>
                      </label>
                      <Field name="amountCurrency" v-slot="{ field }">
                        <Multiselect :options="currencyOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" />
                      </Field>
                      <ErrorMessage name="amountCurrency" class="text-danger" />
                    </div>
                  </div>
                </div>

                <!-- GROUPAGE / CONVENTIONNEL / VRAC -->
                <div v-if="['GROUPAGE', 'CONVENTIONNEL', 'VRAC'].includes(selectedPackagingType)" class="row">
                  <div class="col-md-12 mb-2">
                    <div class="alert alert-success">
                      <strong>Tarification {{
                        selectedPackagingType === 'GROUPAGE' ? 'Groupage' :
                          selectedPackagingType === 'CONVENTIONNEL' ? 'Conventionnel/Vrac' :
                            'Vrac navire complet'
                      }}</strong>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Taille de la tranche (m/t) <span class="text-danger">*</span>
                      </label>
                      <Field name="trancheSize" type="number" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="300" />
                      <ErrorMessage name="trancheSize" class="text-danger" />
                      <small class="text-muted">Tonnes métriques par tranche (ex: 300)</small>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Unité de mesure <span class="text-danger">*</span>
                      </label>
                     <Field name="unitOfMeasure" v-slot="{ field }">
                        <Multiselect :options="unitOfMeasureOptions" :searchable="false" track-by="label" label="label"
                          v-model="field.value" v-bind="field" :disabled="true" />
                      </Field>
                      <ErrorMessage name="unitOfMeasure" class="text-danger" />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Max par ECTN (m/t) <span class="text-danger">*</span>
                      </label>
                      <Field name="maxPerEctn" type="number" class="form-control shadow-none fs-md-15 text-black"
                        placeholder="300" />
                      <ErrorMessage name="maxPerEctn" class="text-danger" />
                      <small class="text-muted">Ex: 300 tonnes maximum par ECTN</small>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Tarif applicable <span class="text-danger">*</span>
                      </label>
                      <Field name="amountForOrigin" type="number" step="0.01"
                        class="form-control shadow-none fs-md-15 text-black" placeholder="25" />
                      <ErrorMessage name="amountForOrigin" class="text-danger" />
                      <small class="text-muted">Par tranche de {{ values.trancheSize || 300 }} m/t</small>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Devise <span class="text-danger">*</span>
                      </label>
                      <Field name="amountCurrency" v-slot="{ field }">
                        <Multiselect :options="currencyOptions" :searchable="true" track-by="label" label="label"
                          v-model="field.value" v-bind="field" />
                      </Field>
                      <ErrorMessage name="amountCurrency" class="text-danger" />
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!-- ========== VALUE_BRACKET ========== -->
            <!-- <div v-if="selectedEntityType === 'VALUE_BRACKET'">
              <div class="col-md-12 mb-3">
                <div class="alert alert-info">
                  <strong>Tranche de valeur :</strong> Cette règle ne s'appliquera que si la valeur totale du BESC est
                  dans la tranche définie (toujours en EUROS)
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Valeur minimum (EUROS) <span class="text-danger">*</span>
                  </label>
                  <Field name="minDeclaredValue" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 0" />
                  <ErrorMessage name="minDeclaredValue" class="text-danger" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Valeur maximum (EUROS) <span class="text-danger">*</span>
                  </label>
                  <Field name="maxDeclaredValue" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 10000000" />
                  <ErrorMessage name="maxDeclaredValue" class="text-danger" />
                  <small class="text-muted">Laissez vide ou mettez un très grand nombre pour "illimité"</small>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Taux % <span class="text-danger">*</span>
                  </label>
                  <Field name="percentageRate" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 0.05" />
                  <ErrorMessage name="percentageRate" class="text-danger" />
                  <small class="text-muted">% de la valeur déclarée</small>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    OU Montant fixe (EUROS)
                  </label>
                  <Field name="baseAmount" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 10000" />
                  <ErrorMessage name="baseAmount" class="text-danger" />
                  <small class="text-muted">Si renseigné, ce montant fixe sera appliqué au lieu du pourcentage</small>
                </div>
              </div>
            </div> -->
          </div>

          <!-- ===== ÉTAPE 4 : OPTIONS AVANCÉES (facultatif) ===== -->
          <div v-if="selectedEntityType" class="row">
            <div class="col-md-12 mt-4 mb-3">
              <div class="alert alert-secondary">
                <strong>Étape 4 :</strong> Options avancées (facultatif)
              </div>
            </div>

            <!-- Ligne 1 : Dates et Priorité -->
            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Date de début</label>
                <Field name="effectiveFrom" type="date" class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="effectiveFrom" class="text-danger" />
                <small class="text-muted">Laissez vide pour appliquer immédiatement</small>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Date de fin</label>
                <Field name="effectiveTo" type="date" class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="effectiveTo" class="text-danger" />
                <small class="text-muted">Laissez vide pour "sans limite"</small>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Priorité</label>
                <Field name="priority" v-slot="{ field }">
                  <Multiselect :options="priorityOptions" :searchable="false" track-by="label" label="label"
                    v-model="field.value" v-bind="field" placeholder="Normale (100) par défaut" />
                </Field>
                <ErrorMessage name="priority" class="text-danger" />
                <small class="text-muted">Plus le nombre est bas, plus prioritaire</small>
              </div>
            </div>

            <!-- Ligne 2 : Autres options -->
            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Régime douanier (optionnel)</label>
                <Field name="regimedouanierId" v-slot="{ field }">
                  <Multiselect :options="regimeDouanierOptions" :searchable="true" track-by="label" label="label"
                    v-model="field.value" v-bind="field" placeholder="Sélectionner un régime" />
                </Field>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Montant min facturé</label>
                <Field name="minFeeAmount" type="number" step="0.01"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 1000" />
                <small class="text-muted">Plafond minimum</small>
              </div>
            </div>

            <div class="col-md-4">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Montant max facturé</label>
                <Field name="maxFeeAmount" type="number" step="0.01"
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 100000" />
                <small class="text-muted">Plafond maximum</small>
              </div>
            </div>

            <!-- Checkboxes -->
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <div class="d-flex flex-wrap gap-5 align-items-center">
                  <div class="form-check">
                    <Field name="isExemptionRule" type="checkbox" class="form-check-input" id="isExemptionRule"
                      :value="true" />
                    <label class="form-check-label text-black fw-semibold" for="isExemptionRule">
                      Règle d'exemption (réduction)
                    </label>
                  </div>
                  <div class="form-check">
                    <Field name="isActive" type="checkbox" class="form-check-input" id="isActive" :value="true"
                      checked />
                    <label class="form-check-label text-black fw-semibold" for="isActive">
                      Activer cette règle immédiatement
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Taux d'exemption conditionnel -->
            <div v-if="pricingRuleForm?.values?.isExemptionRule">
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Taux d'exemption (%)
                  </label>
                  <Field name="exemptionRate" type="number" step="0.01"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Ex: 10" />
                  <ErrorMessage name="exemptionRate" class="text-danger" />
                  <small class="text-muted">% de réduction</small>
                </div>
              </div>
            </div>

            <!-- Description -->
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10">Description</label>
                <Field name="description" as="textarea" rows="3" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Décrivez cette règle en détail..." />
              </div>
            </div>

            <!-- Boutons -->
            <div class="col-md-12 mt-4">
              <div class="d-flex align-items-center">
                <button type="submit"
                  class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success">
                  Ajouter la règle
                </button>
                <router-link to="/listeBescPricingRule"
                  class="btn btn-danger transition border-0 lh-1 fw-medium pt-10 pb-10 ps-25 pe-25">
                  Annuler
                </router-link>
              </div>
            </div>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>


<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect'
export default defineComponent({
  name: "AddPricingRule",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  setup: () => {
    const selectedEntityType = ref<string | null>(null);
    const selectedPackagingType = ref<string | null>(null);
    const pricingRuleForm = ref<any>(null);
    const containerTypeOptions = ref([]);

    const entityTypeHelp = computed(() => {
      const helps: Record<string, { title: string; description: string }> = {
        'BESC': {
          title: 'BESC - Frais de dossier',
          description: 'Un montant fixe sera appliqué une seule fois par dossier BESC, quel que soit son contenu.'
        },
        'BL': {
          title: 'BL - Frais par connaissement',
          description: 'Le montant sera multiplié par le nombre de BL (connaissements) dans le BESC.'
        },
        'CONTAINER': {
          title: 'CONTAINER - Frais par conteneur',
          description: 'Le montant sera multiplié par le nombre de conteneurs. Utilisez ce type pour des frais généraux par conteneur (ex: frais de manutention).'
        },
        'GOODS': {
          title: 'GOODS - Marchandises avec conditionnement',
          description: 'Permet d\'appliquer la grille tarifaire selon le type de conditionnement (FCL, Roulant, Groupage, etc.). Les tarifs varient selon l\'origine du port de chargement.'
        },
        // 'VALUE_BRACKET': {
        //   title: 'VALUE_BRACKET - Frais par tranche de valeur',
        //   description: 'La règle ne s\'appliquera que si la valeur totale du BESC est dans la tranche définie (toujours en EUROS). Utile pour les taxes progressives.'
        // }
      };
      return selectedEntityType.value ? helps[selectedEntityType.value] : { title: '', description: '' };
    });

    // Dans la section <script>, remplace la fonction onEntityTypeChange par ceci :
    const onEntityTypeChange = (value: any) => {
      const entityValue = value?.value || value;
      selectedEntityType.value = entityValue;
      selectedPackagingType.value = null;

      if (pricingRuleForm.value) {
        const form = pricingRuleForm.value;

        // Reset TOUS les champs spécifiques
        form.setFieldValue('baseAmount', null);
        form.setFieldValue('perContainerAmount', null);
        form.setFieldValue('percentageRate', null);
        form.setFieldValue('minDeclaredValue', null);
        form.setFieldValue('maxDeclaredValue', null);
        form.setFieldValue('categorieProduitId', null);
        form.setFieldValue('metadata', {});
        form.setFieldValue('regimedouanierId', null);
        form.setFieldValue('minFeeAmount', null);
        form.setFieldValue('maxFeeAmount', null);
        form.setFieldValue('isExemptionRule', false);
        form.setFieldValue('exemptionRate', null);

        // Reset champs conditionnement
        form.setFieldValue('packagingType', null);
        form.setFieldValue('trancheSize', null);
        form.setFieldValue('unitOfMeasure', null);
        form.setFieldValue('minWeight', null);
        form.setFieldValue('maxWeight', null);
        form.setFieldValue('maxPerEctn', null);
        form.setFieldValue('amountForOrigin', null);

        // Pré-remplissage selon type d'entité
        if (entityValue === 'CONTAINER') {
          // form.setFieldValue('trancheSize', 5);
          form.setFieldValue('unitOfMeasure', 'CONTENEUR'); // pré-rempli Conteneur(s)
          // form.setFieldValue('amountForOrigin', 25);
          // form.setFieldValue('amountCurrency', { value: 'EUR', label: 'EUR - Euro' });
        } else if (entityValue === 'GOODS') {
          // par défaut unité à TONNE_METRIQUE, sera surchargée par le packaging type si nécessaire
          form.setFieldValue('unitOfMeasure', 'TONNE_METRIQUE');
          // form.setFieldValue('amountCurrency', { value: 'EUR', label: 'EUR - Euro' });
        }

        // Définir la devise et priorité par défaut
        if (!form.values.priority) form.setFieldValue('priority', { value: 100, label: 'Normale (100)' });
        if (form.values.isActive === undefined) form.setFieldValue('isActive', true);
      }
    };



    const onPackagingTypeChange = (value: any) => {
  const packagingValue = value?.value || value;
  selectedPackagingType.value = packagingValue;

  if (pricingRuleForm.value) {
    const form = pricingRuleForm.value;

    // Reset champs conditionnement
    form.setFieldValue('trancheSize', null);
    form.setFieldValue('unitOfMeasure', null);
    form.setFieldValue('minWeight', null);
    form.setFieldValue('maxWeight', null);
    form.setFieldValue('maxPerEctn', null);
    form.setFieldValue('amountForOrigin', null);

    // Pré-remplissage unité selon type
    switch (packagingValue) {
      case 'FCL':
        // form.setFieldValue('trancheSize', 5);
        form.setFieldValue('unitOfMeasure', 'CONTENEUR'); // Conteneur(s)
        // form.setFieldValue('amountForOrigin', 25);
        // form.setFieldValue('amountCurrency', { value: 'EUR', label: 'EUR - Euro' });
        break;

      case 'ROULANT':
        // form.setFieldValue('minWeight', 0);
        // form.setFieldValue('maxWeight', 4.99);
        form.setFieldValue('unitOfMeasure', 'VEHICULE'); // Véhicule(s)
        // form.setFieldValue('maxPerEctn', 1);
        // form.setFieldValue('amountForOrigin', 25);
        // form.setFieldValue('amountCurrency', { value: 'EUR', label: 'EUR - Euro' });
        break;

      case 'GROUPAGE':
      case 'CONVENTIONNEL':
      case 'VRAC':
        // form.setFieldValue('trancheSize', 300);
        form.setFieldValue('unitOfMeasure', 'TONNE_METRIQUE'); // Tonne(s) métrique(s)
        // form.setFieldValue('maxPerEctn', 300);
        // form.setFieldValue('amountForOrigin', 25);
        // form.setFieldValue('amountCurrency', { value: 'EUR', label: 'EUR - Euro' });
        break;
    }
  }
};

    // Schéma de validation dynamique
    const pricingRuleSchema = computed(() => {
      const baseSchema: any = {
        code: Yup.string().required('Le code est obligatoire'),
        name: Yup.string().required("Le nom est obligatoire"),
        tariffZoneId: Yup.string().required("La zone tarifaire est obligatoire"),
        appliesToEntityType: Yup.string().required("Le type d'entité est obligatoire"),
        effectiveFrom: Yup.date().nullable().notRequired(),
        priority: Yup.number()
          .integer('La priorité doit être un nombre entier')
          .min(1, 'La priorité doit être au moins 1')
          .max(999, 'La priorité ne peut pas dépasser 999')
          .nullable()
          .notRequired()
          .default(100),
      };

      // Validation conditionnelle selon le type d'entité
      switch (selectedEntityType.value) {
        case 'BESC':
        case 'BL':
          baseSchema.baseAmount = Yup.number()
            .required("Le montant de base est obligatoire")
            .min(0.01, "Le montant doit être supérieur à 0");
          baseSchema.amountCurrency = Yup.string().required("La devise est obligatoire");
          break;

        case 'CONTAINER':
          baseSchema.trancheSize = Yup.number().required("La taille de tranche est obligatoire").min(1);
          baseSchema.unitOfMeasure = Yup.string().required("L'unité de mesure est obligatoire");
          baseSchema.maxPerEctn = Yup.number().nullable();
          baseSchema.amountForOrigin = Yup.number().required("Le tarif est obligatoire").min(0.01);
          baseSchema.amountCurrency = Yup.string().required("La devise est obligatoire");
          baseSchema['metadata.containerTypes'] = Yup.array().min(1, "Au moins un type de conteneur requis");
          break;

        case 'GOODS':
          // Obliger le packagingType : plus de GOODS "classique" sans conditionnement
          baseSchema.packagingType = Yup.string().required("Le type de conditionnement est obligatoire");

          if (selectedPackagingType.value) {
            switch (selectedPackagingType.value) {
              case 'FCL':
                baseSchema.trancheSize = Yup.number().required("La taille de tranche est obligatoire").min(1);
                baseSchema.unitOfMeasure = Yup.string().required("L'unité de mesure est obligatoire");
                baseSchema.maxPerEctn = Yup.number().nullable();
                baseSchema.amountForOrigin = Yup.number().required("Le tarif  est obligatoire").min(0.01);
                // baseSchema.amountForDistantOrigin = Yup.number().required("Le tarif autres origines est obligatoire").min(0.01);
                break;

              case 'ROULANT':
                baseSchema.minWeight = Yup.number().required("Le poids minimum est obligatoire").min(0);
                baseSchema.maxWeight = Yup.number()
                  .nullable()
                  .min(Yup.ref('minWeight'), "Le poids max doit être ≥ au poids min");
                baseSchema.unitOfMeasure = Yup.string().required("L'unité de mesure est obligatoire");
                baseSchema.maxPerEctn = Yup.number().required("Le max par ECTN est obligatoire").min(1);
                baseSchema.amountForOrigin = Yup.number().required("Le tarif obligatoire").min(0.01);
                // baseSchema.amountForDistantOrigin = Yup.number().required("Le tarif autres origines est obligatoire").min(0.01);
                break;

              case 'GROUPAGE':
              case 'CONVENTIONNEL':
              case 'VRAC':
                baseSchema.trancheSize = Yup.number().required("La taille de tranche est obligatoire").min(1);
                baseSchema.unitOfMeasure = Yup.string().required("L'unité de mesure est obligatoire");
                baseSchema.maxPerEctn = Yup.number().required("Le max par ECTN est obligatoire").min(1);
                baseSchema.amountForOrigin = Yup.number().required("Le tarif est obligatoire").min(0.01);
                // baseSchema.amountForDistantOrigin = Yup.number().required("Le tarif autres origines est obligatoire").min(0.01);
                break;
            }

            // Devise obligatoire pour tous les GOODS avec conditionnement
            baseSchema.amountCurrency = Yup.string().required("La devise est obligatoire");
          }
          break;

        // case 'VALUE_BRACKET':
        //   baseSchema.minDeclaredValue = Yup.number()
        //     .required("La valeur minimum est obligatoire")
        //     .min(0, "La valeur doit être positive ou nulle");
        //   baseSchema.maxDeclaredValue = Yup.number()
        //     .nullable()
        //     .min(Yup.ref('minDeclaredValue'), "La valeur max doit être supérieure à la valeur min");
        //   baseSchema.percentageRate = Yup.number()
        //     .test(
        //       'percentage-or-base',
        //       'Vous devez renseigner soit le taux %, soit le montant fixe',
        //       function (value) {
        //         const { baseAmount } = this.parent;
        //         return (value && value > 0) || (baseAmount && baseAmount > 0);
        //       }
        //     );
        //   break;
      }

      // Champs optionnels généraux
      baseSchema.minFeeAmount = Yup.number().min(0).nullable();
      baseSchema.maxFeeAmount = Yup.number().min(0).nullable();
      baseSchema.exemptionRate = Yup.number()
        .nullable()
        .when('isExemptionRule', {
          is: true,
          then: (schema) => schema.required("Le taux d'exemption est obligatoire").min(0.01).max(100),
          otherwise: (schema) => schema.nullable(),
        });

      return Yup.object().shape(baseSchema);
    });

    const tariffZoneOptions = ref([]);
    const categProduitOptions = ref([]);
    const regimeDouanierOptions = ref([]);
    const router = useRouter();


    const entityTypeOptions = ref([
      // { value: 'BESC', label: ' BESC - Dossier complet' },
      // { value: 'BL', label: ' BL - Connaissement' },
      { value: 'CONTAINER', label: ' CONTAINER - Conteneur' },
      // { value: 'CARGO_LINE', label: ' CARGO_LINE - Ligne de marchandise' },
      { value: 'GOODS', label: ' GOODS - Marchandises (par catégorie)' },
      // { value: 'VALUE_BRACKET', label: ' VALUE_BRACKET - Tranche de valeur' }
    ]);

    const packagingTypeOptions = ref([
      // { value: 'FCL', label: ' FCL - Conteneurs pleins' },
      { value: 'ROULANT', label: ' Roulant' },
      { value: 'GROUPAGE', label: ' Groupage' },
      { value: 'CONVENTIONNEL', label: ' Conventionnel/Vrac' },
      { value: 'VRAC', label: ' Vrac navire complet' }
    ]);

    const unitOfMeasureOptions = ref([
      { value: 'CONTENEUR', label: 'Conteneur(s)' },
      { value: 'VEHICULE', label: 'Véhicule(s)' },
      { value: 'TONNE_METRIQUE', label: 'Tonne(s) métrique(s)' }
    ]);

    const priorityOptions = ref([
      { value: 1, label: 'Très élevée (1)' },
      { value: 10, label: 'Élevée (10)' },
      { value: 50, label: 'Moyenne (50)' },
      { value: 100, label: 'Normale (100)' },
      { value: 200, label: 'Basse (200)' }
    ]);

    const currencyOptions = ref([
      { value: 'XOF', label: 'XOF - Franc CFA' },
      { value: 'EUR', label: 'EUR - Euro' },
      { value: 'USD', label: 'USD - Dollar américain' },
      { value: 'GBP', label: 'GBP - Livre sterling' }
    ]);

    const regionOptions = ref([
      'AFRIQUE',
      'EUROPE',
      'ASIE',
      'AMERIQUE',
      'OCEANIE'
    ]);

    const fetchTariffZones = async () => {
      try {
        const response = await ApiService.get('/tariff-zones?limit=0');
        const zoneData = response.data.data.data;
        tariffZoneOptions.value = zoneData.map((zone) => ({
          value: zone.id,
          label: `${zone.code} - ${zone.name}`,
        }));
      } catch (err) {
        console.error('Erreur chargement zones tarifaires:', err);
      }
    };
    const fetchCategProduit = async () => {
      try {
        const response = await ApiService.get('/categProduits?limit=0');
        const categData = response.data.data.data;
        categProduitOptions.value = categData.map((categProduit) => ({
          value: categProduit.id,
          label: `${categProduit.name}`
        }))
      } catch (err) {
        console.error('Erreur chargement catégories:', err);
      }
    }
    const fetchRegime = async () => {
      try {
        const response = await ApiService.get('/regimes?limit=0');
        const regimeData = response.data.data.data;
        regimeDouanierOptions.value = regimeData.map((regimeDouanier) => ({
          value: regimeDouanier.id,
          label: `${regimeDouanier.name}`,
        }));
      } catch (err) {
        console.error('Erreur chargement régimes:', err);
      }
    }
    const fetchContainerTypes = async () => {
      try {
        const response = await ApiService.get('/type-containers');
        const typesData = response.data.data.data;
        containerTypeOptions.value = typesData.map((typeContainer) => ({
          value: typeContainer.id,
          label: `${typeContainer.libelle}`
        }));
      } catch (err) {
        console.error('Erreur chargement types de conteneurs:', err);
      }
    };


    const addPricingRule = async (values: any, { resetForm }) => {

      const payload: any = {
        code: values.code,
        name: values.name,
        description: values.description || null,
        tariffZoneId: values.tariffZoneId?.value || values.tariffZoneId,
        appliesToEntityType: values.appliesToEntityType?.value || values.appliesToEntityType,

        priority: values.priority?.value || values.priority || 100,
        isActive: values.isActive === true,
        isExemptionRule: values.isExemptionRule === true,
        exemptionRate: values.exemptionRate || null,
        effectiveFrom: values.effectiveFrom || null,
        effectiveTo: values.effectiveTo || null,
        minFeeAmount: values.minFeeAmount || null,
        maxFeeAmount: values.maxFeeAmount || null,
        categorieProduitId: values.categorieProduitId?.value || values.categorieProduitId || null,
        regimedouanierId: values.regimedouanierId?.value || values.regimedouanierId || null,
      };

      const entityType = payload.appliesToEntityType;

      switch (entityType) {
        case 'BESC':
        case 'BL':
          payload.baseAmount = values.baseAmount;
          payload.amountCurrency = values.amountCurrency?.value || values.amountCurrency || 'EUR';
          break;

        case 'CONTAINER': {
          payload.trancheSize = values.trancheSize ? Number(values.trancheSize) : null;
          payload.unitOfMeasure = values.unitOfMeasure?.value || values.unitOfMeasure || null;
          payload.maxPerEctn = values.maxPerEctn ? Number(values.maxPerEctn) : null;
          payload.amountCurrency = values.amountCurrency?.value || values.amountCurrency || 'EUR';

          const tarifContainer = values.amountForOrigin ? Number(values.amountForOrigin) : 0;

          payload.metadata = {
            containerTypes: values.metadata?.containerTypes?.map((item: any) => item.value || item) || [],
            requireDistantOrigin: values.metadata?.requireDistantOrigin || false,
            origins: tarifContainer
          };
          break;
        }
        case 'GOODS': {
          payload.packagingType = values.packagingType?.value || values.packagingType;
          payload.amountCurrency = values.amountCurrency?.value || values.amountCurrency || 'EUR';

          if (payload.packagingType) {
            payload.trancheSize = values.trancheSize ? Number(values.trancheSize) : null;
            payload.unitOfMeasure = values.unitOfMeasure?.value || values.unitOfMeasure || null;
            payload.minWeight = values.minWeight ? Number(values.minWeight) : null;
            payload.maxWeight = values.maxWeight ? Number(values.maxWeight) : null;
            payload.maxPerEctn = values.maxPerEctn ? Number(values.maxPerEctn) : null;

            const tarifOrigine = values.amountForOrigin ? Number(values.amountForOrigin) : 0;

            payload.metadata = {
              origins: tarifOrigine
            };

            console.log(' Metadata créé:', payload.metadata);
          }
          break;
        }

        // case 'VALUE_BRACKET':
        //   payload.minDeclaredValue = values.minDeclaredValue;
        //   payload.maxDeclaredValue = values.maxDeclaredValue || null;
        //   payload.percentageRate = values.percentageRate || null;
        //   payload.baseAmount = values.baseAmount || null;
        //   payload.amountCurrency = 'EUROS';
        //   break;
      }

      if (payload.metadata && Object.keys(payload.metadata).length > 0) {
        payload.metadata = JSON.stringify(payload.metadata);
      } else if (payload.metadata) {
        delete payload.metadata;
      }

      console.log(' Payload final envoyé:', JSON.stringify(payload, null, 2));

      try {
        const { data } = await ApiService.post("/pricing-rule", payload);
        if (data.code == 201) {
          success(data.message);
          resetForm();
          router.push({ name: "ListeBescPricingRulePage" });
        }
      } catch (err: any) {
        console.error(' Erreur API:', err.response?.data);
        error(err.response?.data?.message || "Erreur lors de l'ajout de la règle");
      }
    };


    onMounted(() => {
      fetchTariffZones();
      fetchCategProduit();
      fetchRegime();
      fetchContainerTypes();
    });

    return {
      addPricingRule,
      pricingRuleSchema,
      pricingRuleForm,
      selectedEntityType,
      selectedPackagingType,
      entityTypeHelp,
      onEntityTypeChange,
      onPackagingTypeChange,
      tariffZoneOptions,
      categProduitOptions,
      regimeDouanierOptions,
      entityTypeOptions,
      packagingTypeOptions,
      unitOfMeasureOptions,
      priorityOptions,
      currencyOptions,
      regionOptions,
      containerTypeOptions
    };
  },
});
</script>